<template>
  <div id="pageTable" class="subView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar dark color="primary" flat dense cad>
              <v-btn icon @click="$router.go(-1)">
                <v-icon>keyboard_arrow_left</v-icon>
              </v-btn>
              <v-toolbar-title class="subheading">쿠폰 발급 내역</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-list three-line subheader>
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                :rows-per-page-items="[10,25,50]"
                class="elevation-1"
                item-key="id"
                must-sort
                :total-items="totalItems"
                :loading="loading"
                :pagination.sync="pagination"
                >
                <template slot="items" slot-scope="props">            
                  <td class="text-sm-center">{{ props.item.id }}</td>
                  <td class="text-sm-center">{{ props.item.coupon.title }}</td>
                  <td class="text-sm-center">{{ changeCouponTypeText(props.item.couponType) }}</td>
                  <td class="text-sm-center">{{ (props.item.userType === 'P' ? '승객' : '기사') + ' ' + props.item.userId }}</td>
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                  <td class="text-sm-center">{{ props.item.expDate }}</td>
                  <td class="text-sm-center">{{ props.item.usedDate }}</td>
                </template>
              </v-data-table>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import State  from '@/api/couponType';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      pagination: {
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      searchFormModel: {
        filter: 'name',
        filterText: ''
      },
      totalItems: 0,
      loading: true,
      complex: {
        headers: [
          {
            text: '발급 번호',
            value: 'id',
            align: 'center'
          },
          {
            text: '쿠폰 이름',
            value: 'title',
            align: 'center',
            sortable: false
          },
          {
            text: '종류',
            value: 'couponType',
            align: 'center',
            sortable: false
          },
          {
            text: '발급대상',
            value: 'userType',
            align: 'center',
            sortable: false
          },
          {
            text: '발급일',
            value: 'regDate',
            align: 'center'
          },
          {
            text: '만료일',
            value: 'expDate',
            align: 'center'
          },
          {
            text: '사용일',
            value: 'usedDate',
            align: 'center'
          }
        ],
        items: []
      },
      state: State,
    };
  },
  watch: {
      pagination: {
          handler () {
              this.banbanCreated();
          },
          deep: true
      }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
  },
  methods: {
    banbanCreated () {
      this.loading = true;

      const parameters = {
        method: 'couponHistories',
        'id': this.$route.params.id,
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchFormModel.filter,
        filterText: this.searchFormModel.filterText
      };

      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          if (data.statusCode != null && data.statusCode != '200'){
            throw data.message;
          }
          this.complex.items = data.content;
          this.totalItems = data.totalElements;
          this.loading = false;
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    changeCouponTypeText (couponType) {
      if (couponType != null) {
        for (let i = 0; i < this.state.length; i++) {
          if (this.state[i].state === couponType) {
            return this.state[i].text;
          }
        }
      } else {
        return '-';
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/coupon/CouponHistories.vue